import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import ProductCard from "../components/ProductCard";
import { fetchProducts } from "../api"; // API call
import "./Home.css";

export default function Home({ addToCart }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts()
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <section className="hero-section text-center">
        <Container>
          <h1 className="hero-title">Welcome to ShopeSphere</h1>
          <p className="hero-subtitle">
            Where Style Meets Performance. Shop the latest gadgets today.
          </p>
        </Container>
      </section>

      <Container className="product-grid mt-5">
        <h2 className="section-heading text-dark mb-4">Featured Products</h2>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="warning" />
          </div>
        ) : (
          <Row className="g-4">
            {products.map(product => (
              <Col key={product.product_id} xs={12} md={6} lg={4}>
                <ProductCard product={product} addToCart={addToCart} />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
}
